import React from 'react';
import like from '../../src/images/icons/likeReview.svg'
import share from '../../src/images/icons/share.svg'
import { useParams } from 'react-router-dom';
import StarRating from './rating';

function ReviewCard(props) {
    const getFirstLetter = (str) => {
        return str.charAt(0);
      };

    const { busId } = useParams();

    const shareReview = () => {
        navigator.clipboard.writeText('https://yebokenny.com/business-details/'+busId+'#'+props.feedbackId)
        .then(() => {
            alert('Link copied to clipboard!');
        })
        .catch((err) => {
            console.error('Failed to copy: ', err);
        });
    };

    const likeReview = () => {
        alert('Like recorded!')
    }
    return (
        <div id={props.feedbackId} className='flex flex-col space-y-3'>
            <div className='flex flex-row space-x-2 items-center'>
                <span className='rounded-full grid p-1 bg-[#4CA9FF] h-[40px] w-[40px] text-white text-[13px]'><span className='my-auto'>{getFirstLetter(props.feedbackName ? props.feedbackName : 'Amonymous')}</span></span>
                <span className='text-[16px] font-[400]'>{!props.feedbackWriter || props.feedbackWriter == '' ? 'Anonymous' : props.feedbackWriter}</span>
                <span className='cursor-pointer' onClick={likeReview}><img src={like} /></span>
                <span className='cursor-pointer' onClick={shareReview}><img src={share} /></span>
            </div>
            <div className='text-[20px] font-[400] text-start'>{props.title? props.title : ''}</div>
            <StarRating rating={Number(props.feedbackRating) || 0} maxRating={5} readOnly />
            <div className='text-[#545454] text-[14px] text-start'>
                {props.feedbackValue}
            </div>
            { (props.feedbackImage1 || props.feedbackImage2) ?
            <>
            <div className='text-semibold text-start'>Review Images</div>
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2 text-start">
                {props.feedbackImage1 ?
                 <div className="w-[150px] h-[120px]">
                    <img className='w-full h-full' src={props.feedbackImage1}/>
                </div>
                : ''}
                {props.feedbackImage2 ?
                    <div className="w-[150px] h-[120px]">
                        <img className='w-full h-full' src={props.feedbackImage2}/>
                    </div>
                : ''}
            </div>
            </>
            : ''
            }
            <div><hr></hr></div>
        </div>
    );
}

export default ReviewCard;